import React from 'react';
import { AdminTabBar } from './components/admin/AdminTabBar';
import { DebugProvider } from './view-system/debug/DebugContext';
export type AdminLayoutActiveKey =
	| 'admin'
	| 'artifacts'
	| 'fixtures'
	| 'users'
	| 'queue'
	| 'usage'
	| 'action-defs'
	| 'logs'
	| 'dbos'
	| 'workflows';

type AdminLayoutProps = {
	children: React.ReactNode;
	activeKey?: AdminLayoutActiveKey;
};

export default function AdminLayout({ children }: AdminLayoutProps) {
	return (
		<div className="flex h-full">
			<div className="flex-1 flex flex-col min-w-0">
				<AdminTabBar />
				<DebugProvider>
					<div className="flex-1 overflow-auto px-6 pb-6 pt-2">
						{children}
					</div>
				</DebugProvider>
			</div>
		</div>
	);
}
